import { ReactNode } from "react";

import TooltipInfo from "ds/components/TooltipInfo";
import useTypedContext from "hooks/useTypedContext";
import { LicenseExpirationStatus } from "views/SelfHosted/LicenseProvider/types";
import { SelfHostedLicenseContext } from "views/SelfHosted/LicenseProvider/Context";
import { IconProps } from "ds/components/Icon";
import { AriaOnlyText } from "components/AriaOnlyText";
import Box from "ds/components/Box";
import { MainNavigationMenuItem } from "components/MainNavigation/types";
import useMainNavigationActiveStates from "components/MainNavigation/hooks/useActiveStates";
import MainNavigationDropdownMenuItem from "components/MainNavigation/components/atoms/DropdownMenu/Item";

const getLicenseExpirationStatusProps = (
  licenseExpirationStatus?: LicenseExpirationStatus
): { color: IconProps["color"]; tooltip: string } | null => {
  if (licenseExpirationStatus === LicenseExpirationStatus.EXPIRED) {
    return {
      color: "danger",
      tooltip: "The license expired",
    };
  }
  if (licenseExpirationStatus === LicenseExpirationStatus.LAST_DAY) {
    return {
      color: "danger",
      tooltip: "The license expires today",
    };
  }
  if (licenseExpirationStatus === LicenseExpirationStatus.IN_2_WEEKS) {
    return {
      color: "danger",
      tooltip: "The license will expire soon",
    };
  }
  if (licenseExpirationStatus === LicenseExpirationStatus.IN_2_MONTHS) {
    return {
      color: "warning",
      tooltip: "The license will expire soon",
    };
  }

  return null;
};

type MainNavigationAccountDetailsMenuItemProps = {
  onCloseDropdown?: () => void;
  item: MainNavigationMenuItem;
};

const MainNavigationAccountDetailsMenuItem = ({
  onCloseDropdown,
  item,
}: MainNavigationAccountDetailsMenuItemProps) => {
  const { licenseExpirationStatus } = useTypedContext(SelfHostedLicenseContext);
  const { activeMenuItemId } = useMainNavigationActiveStates();

  const isActive = item.id === activeMenuItemId;

  const properties = getLicenseExpirationStatusProps(licenseExpirationStatus);

  let content: ReactNode = "Account details";
  if (properties) {
    content = (
      <Box gap="small">
        <TooltipInfo standardIconColor={properties.color} widthMode="maxWidthSm">
          {properties.tooltip}
        </TooltipInfo>
        <span>
          Account details<AriaOnlyText>{`. Warning: ${properties.tooltip}`}</AriaOnlyText>
        </span>
      </Box>
    );
  }

  return (
    <MainNavigationDropdownMenuItem item={item} onCloseDropdown={onCloseDropdown} active={isActive}>
      {content}
    </MainNavigationDropdownMenuItem>
  );
};

export default MainNavigationAccountDetailsMenuItem;
